module.exports = __webpack_public_path__ + "static/scale-model-of-madame-tussauds-hollywood-in-los-angeles-california-f1d4409eee7aecba1e24798bb5329f50.png";